import { AttributesList, createAttributesItem } from 'src/utils/createAttributesItem.ts';
import { filterEmpty } from 'src/utils/filterEmpty.ts';
import { SensorProduct } from 'src/sensors/list/SensorsPageMapping.ts';
import { convertFS } from 'src/sensors/list/convertFS.ts';
import { AttributesAliases } from 'src/generated/dict.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { FlowRangeFields } from 'src/sensors/FlowUnitsRadioButtons/FlowUnitsOptions.ts';
import { convertProbeLength } from './convertProbeLength';

const NO = '@no';

export function prepareSensorAttributes(
    product: SensorProduct,
    isAmericas: boolean,
    isImperial: boolean,
    selectedFlowRange: FlowRangeFields,
): [AttributesList, AttributesList] {
    const attrs: [AttributesList, AttributesList] = [
        [
            [MESSAGES.Description, product.ProductSubHeader],
            ...createAttributesItem(
                AttributesAliases.DisplayType,
                product.DisplayType || { raw: [NO], localized: [NO] },
            ),
            [AttributesAliases.SensorApplication, product.SensorApplication],
            [AttributesAliases.OutputSignal, product.OutputSignal],
        ],
        [
            [AttributesAliases.MeasuredValues, product.MeasuredValues],
            [
                AttributesAliases.ProbeLength,
                isAmericas ? product.ProbeLength : convertProbeLength(product.ProbeLength, isImperial),
            ],
            [AttributesAliases.MeasuringRangeCO2, product.MeasuringRangeCO2],
            ...(isImperial ? [
                [AttributesAliases.i_MeasuringRangeTemperature, product.i_MeasuringRangeTemperature],
            ] : [
                [AttributesAliases.m_MeasuringRangeTemperature, product.m_MeasuringRangeTemperature],
            ]) as AttributesList,
            [AttributesAliases.MeasuringRangeRH, product.MeasuringRangeRH],
            [AttributesAliases.AdditionalFeatures, product.AdditionalFeatures],
            [
                isImperial ? AttributesAliases.i_flow : AttributesAliases.m_flow,
                isImperial ? (product.i_flow || convertFS(product.m_flow, isImperial)) : product.m_flow,
            ],
            ...(selectedFlowRange && selectedFlowRange.length > 0 ? [
                [AttributesAliases[selectedFlowRange], product[selectedFlowRange]],
            ] : []) as AttributesList,
            [AttributesAliases.pressureAir, product.pressureAir],
            [AttributesAliases.certification, product.certification],
            [AttributesAliases.mountingType, product.mountingType],
        ]];

    return [attrs[0].filter(filterEmpty), attrs[1].filter(filterEmpty)];
}
